<template>
  <div class="carrer-page">
    <div class="content-image">
      <v-img class="image-logo" :src="_image">
        <v-img class="gif-logo" :src="_gif"></v-img>
      </v-img>
    </div>
    <div class="content">
      <div class="content-title">Minha carreira...</div>

      <v-timeline :dense="_sizeScreen">
        <v-timeline-item
          v-for="(item, i) in timeline"
          :key="i"
          :color="item.color"
          small
        >
          <template v-slot:opposite>
            <span class="card-text-title">{{ item.year }}</span>
          </template>
          <v-card class="card">
            <v-card-text class="card-text">
              <div v-if="_sizeScreen" class="card-text-title">
                <span>{{ item.year }}</span>
                <br />
              </div>
              {{ item.description }}
            </v-card-text>
          </v-card>
        </v-timeline-item>
      </v-timeline>
    </div>
  </div>
</template>

<script>
import image from "@/assets/paint-brush.png";
import gif from "@/assets/anime-svg.svg";

export default {
  name: "CareerPage",

  data() {
    return {
      timeline: [
        {
          color: "#000000",
          year: "2018",
          description:
            "Iniciei minha carreira como desenvolvedor na Longtech Software, participando do desenvolvimento de uma ERP personalizada para diferentes tipos de empresas utilizando Delphi.",
        },
        {
          color: "#3E4F49",
          year: "2022",
          description:
            "Entrei no mundo do desenvolvimento Web na empresa COMEIA, utilizando o Vuejs 2, vuetify, vuex, vue router como ferramentas de porta de entrada para o Front-end",
        },
        {
          color: "#5A8778",
          year: "2024",
          description:
            "Iniciei alguns trabalhos com o Nodejs para fechar o pacote completo de um desenvolvedor FullStack e me formei na pós-graduação de Engenharia de Software.",
        },
        {
          color: "#CDE2D9",
          year: "2025",
          description:
            "Atualmente desenvolvedor FullStack, já desempenhei alguns papeis de Tech Leader em alguns pequenos projetos e estou buscando sempre novos conhecimentos para aprimorar minha carreira profissional.",
        },
      ],
    };
  },

  components: {},
  computed: {
    _image() {
      return image;
    },
    _gif() {
      return gif;
    },
    _sizeScreen() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
